import {Component, OnInit, AfterViewInit, ElementRef, AfterContentChecked, OnDestroy, ViewChild} from '@angular/core';
import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';
import {HomeComponent} from "./home/home.component";
import {AboutComponent} from "./about/about.component";
import {ProjectsComponent} from "./projects/projects.component";

declare var TimelineMax, TweenMax, jQuery, Power2, Stepped, Sine;

@Component({
    selector: 'app-root',
    providers: [Location, {provide: LocationStrategy, useClass: HashLocationStrategy}],
    templateUrl: './app.component.html',
    styleUrls: ['app.component.less']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(HomeComponent) homeComponent: HomeComponent;
    @ViewChild(AboutComponent) aboutComponent: AboutComponent;
    @ViewChild(ProjectsComponent) projectsComponent: ProjectsComponent;

    isAppEventActivated: boolean = false;
    isPanelActivated: boolean = true;

    tl_app: any;
    sections: Array<any> = ['home', 'about', 'projects'];
    websiteMode: string = 'landing-page';
    activeSection: string = "home";
    nextActiveSection: string = "";

    animatedElems: any = {
        colSeparator: null,
        panelLeft: null,
        panelRight: null
    };

    constructor(private elRef: ElementRef, private location: Location) {
    }

    checkCurrentPath() {
        // let activeHash = this.location.path();
        // if(activeHash && this.sections.inArray(activeHash) > -1){
        //     this.activeSection = activeHash;
        // }
    }

    ngOnInit() {
        // this.checkCurrentPath();

        this.tl_app = new TimelineMax({
            paused: true,
            repeat: 0,
            force3d: true
        });
    }

    ngOnDestroy() {
        this.tl_app.kill();
        this.tl_app = null;
    }

    ngAfterViewInit() {
        this.setupElems();
        this.tl_setUpAnimIntro();

        setTimeout(() => {
            TweenMax.fromTo(this.animatedElems.colSeparator, 1, {
                transform: "scaleY(0)",
                autoAlpha: 0,
                immediateRender: false
            }, {transform: "scaleY(1)", autoAlpha: 1});
        }, 500);
    }

    setupElems() {
        this.animatedElems.colSeparator = jQuery('[col-separator]', this.elRef.nativeElement);
        this.animatedElems.panelLeft = jQuery('[panel-left]', this.elRef.nativeElement);
        this.animatedElems.panelRight = jQuery('[panel-right]', this.elRef.nativeElement);
    }

    onMouseWheelUpFunc(e) {
        if (this.websiteMode == 'landing-page') return;

        if (!this.isAppEventActivated) return;
        this.isAppEventActivated = false;

        let activeSectionIndex: number = this.sections.indexOf(this.activeSection);
        let prevIndex: number = activeSectionIndex - 1;

        prevIndex = (prevIndex < 0 ) ? (this.sections.length - 1) : prevIndex;
        this.onEmitGoToLink(this.sections[prevIndex]);
    }

    onMouseWheelDownFunc(e) {
        if (this.websiteMode == 'landing-page') return;

        if (!this.isAppEventActivated) return;
        this.isAppEventActivated = false;

        let activeSectionIndex: number = this.sections.indexOf(this.activeSection);
        let nextIndex: number = activeSectionIndex + 1;

        nextIndex = (nextIndex == this.sections.length) ? 0 : nextIndex;
        this.onEmitGoToLink(this.sections[nextIndex]);
    }

    tl_setUpAnimIntro() {
        let t_panelLeft = TweenMax.fromTo(this.animatedElems.panelLeft, 1.6, {
            transform: "scaleX(1)",
            immediateRender: false
        }, {transform: "scaleX(0)", ease: Sine.easeInOut});

        let t_panelRight = TweenMax.fromTo(this.animatedElems.panelRight, 1.6, {
            transform: "scaleX(1)",
            immediateRender: false
        }, {transform: "scaleX(0)", ease: Sine.easeInOut});

        this.tl_app.add("anim_panelsSection", 0.1);
        this.tl_app.add([t_panelLeft, t_panelRight], "anim_panelsSection");
    }

    onAnimCloseSectionEnded() {
        this.isPanelActivated = false;
        this.activeSection = this.nextActiveSection;
        this.nextActiveSection = null;

        if (['home', 'projects'].indexOf(this.activeSection) != -1) {
            this.isPanelActivated = true;
        }

        console.log(this.activeSection);
        if (this.activeSection == 'projects') {
            this.tl_app.play();

        }
    }

    onEmitGoToLink(goToSectionName) {
        console.log("onEmitGoToLink", goToSectionName);
        this.nextActiveSection = goToSectionName;

        switch (this.activeSection) {
            case "home":
                this.homeComponent.componentAnimOut();
                this.tl_app.reverse();
                break;
            case "about":
                // this.tl_app.reverse();
                this.aboutComponent.componentAnimOut();
                break;
            case "projects":
                this.tl_app.reverse();
                this.projectsComponent.componentAnimOut();
                break;
        }
    }
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/app.component.ts